import axios from 'axios'
import config from '@/config.js'
import exportConvert from '@/store/export.convert.js'

const API_URL = config.apiUrl
const API_URL_CLIENTSIDE = config.apiUrlClientSide

const state = {
  annotators: [],
  annotator: null
}

const mutations = {
  async setAnnotator(state, annotator){
    if (!config.editable) {
      annotator = await exportConvert.convert("annotator.details", annotator)
    }
    state.annotator = annotator
  },
  setAnnotators(state, annotators){
    state.annotators = annotators
  },
}

const getters = {
  // getArticle: (state) => (id) => state.articles.filter(article => article.id == id),
}

const actions = {
  searchAnnotators({ commit }, options){
    let query = options.query
    let exclude = (options.exclude || []).join(',')
    axios
      .get(`${API_URL}/annotators/autocomplete?query=${query}&exclude=${exclude}`)
      .then(r => r.data)
      .then(annotators => {
        commit('setAnnotators', annotators)
      })
  },
  loadAnnotator({ commit }, id){
    let url = `${API_URL}/annotator/${id}`
    if (!config.editable) {
      url = `${API_URL_CLIENTSIDE}/annotator/${id.slice(0, 2)}/${id}.json`
    }
    axios
      .get(url)
      .then(r => r.data)
      .then(annotator => {
        commit('setAnnotator', annotator)
      })
  },
  saveAnnotator(_, annotator){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/annotator/${annotator.id}`, annotator)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  createAnnotator(_, annotator){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/annotator`, annotator)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  },
  deleteAnnotator(_, annotator){
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/annotator/${annotator.id}`)
        .then(response => {
          this.dispatch('addNotification', {
            type: 'success',
            text: `Annotator deleted`
          })
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
